import { render, staticRenderFns } from "./certificateInformation.vue?vue&type=template&id=982dc90a&scoped=true"
import script from "./certificateInformation.vue?vue&type=script&lang=js"
export * from "./certificateInformation.vue?vue&type=script&lang=js"
import style0 from "./certificateInformation.vue?vue&type=style&index=0&id=982dc90a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982dc90a",
  null
  
)

export default component.exports